import { ConfigStateService, CoreModule, ShowPasswordDirective, SubscriptionService } from '@abp/ng.core';
import { ButtonComponent, ThemeSharedModule } from '@abp/ng.theme.shared';
import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PasswordComplexityIndicatorService, ChangePasswordService, AccountPublicModule } from '@volo/abp.ng.account/public';
import { ChangePasswordFormModel } from '@volo/abp.ng.account/public/models/changePasswordFormModel';
import { ProgressBarStats } from '@volo/abp.ng.account/public/models/password-complexity';
import { switchMap } from 'rxjs';
import { ConfigMenuService } from 'src/app/config-menu/config-menu.service';


@Component({
  selector: 'abp-refresh-password-form',
  templateUrl: './refresh-password.component.html',
  exportAs: 'abpRefreshPasswordForm',
  styleUrl: "./refresh-password.component.scss",
  standalone: true,
  imports: [
    AccountPublicModule,
    ThemeSharedModule,
    CoreModule,
    ShowPasswordDirective
  ],
  providers: [SubscriptionService],
})
export class RefreshPasswordComponent implements OnInit {
  private readonly passwordComplexityService = inject(PasswordComplexityIndicatorService);
  private readonly service = inject(ChangePasswordService);
  protected readonly subscription = inject(SubscriptionService);
  private config = inject(ConfigStateService)
  private configMenu = inject(ConfigMenuService)
  form: FormGroup<any>;
  progressBar: ProgressBarStats;
  showCurrentPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  mapErrorsFn = this.service.MapErrorsFnFactory();

  
  acceptPrivacyPolicyValidator(control: FormControl): { [key: string]: any } | null {
    return control.value === true ? null : { privacyNotAccepted: true };
  }

  ngOnInit(): void {
    this.form = this.service.buildForm();

    // Adiciona o checkbox
    this.form.setControl(
      'acceptPrivacyPolicy',
      new FormControl(false, this.acceptPrivacyPolicyValidator)
    );
  }

  onSuccess() {
    this.configMenu.configGlobal()
    this.configMenu.configTenants()
    const sub = this.service.redirectToReturnUrl();
    this.subscription.addOne(sub);
  }

  onSubmit() {
    if (this.form.invalid) return;
    const input = this.form.value
    const sub = this.service.changePasswordAndLogin({ currentPassword:input.currentPassword, newPassword:input.newPassword }).pipe(
      switchMap(() => {
         return this.config.refreshAppState()
      })
    ).subscribe({
      next: () => this.onSuccess(),
      error: e => this.service.showErrorMessage(e)
    } 
     );

  }

  get newPassword():string{
    return this.form.get('newPassword').value
  }

  validatePassword(){
    this.progressBar = this.passwordComplexityService.validatePassword(this.newPassword);
  }
}
